import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 90000 });

export const api = {
  // Setups
  listSetups: () => http.get("/setups").then(r => r.data),
  getSetup: (id) => http.get(`/setups/${id}`).then(r => r.data),
  createSetup: (data) => http.post("/setups", data).then(r => r.data),
  updateSetup: (id, data) => http.patch(`/setups/${id}`, data).then(r => r.data),
  deleteSetup: (id) => http.delete(`/setups/${id}`).then(r => r.data),
  resetTriggers: (id) => http.post(`/setups/${id}/reset-triggers`).then(r => r.data),
  analyzeUrl: (url) => http.post("/setups/analyze-url", { url }).then(r => r.data),
  analyzeText: (text, source_url) => http.post("/setups/analyze-text", { text, source_url }).then(r => r.data),
  // Settings
  getSettings: () => http.get("/settings").then(r => r.data),
  saveSettings: (data) => http.put("/settings", data).then(r => r.data),
  testTelegram: () => http.post("/settings/test-telegram").then(r => r.data),
  detectChatId: () => http.post("/settings/detect-chat-id").then(r => r.data),
  // Alerts
  listAlerts: () => http.get("/alerts").then(r => r.data),
  clearAlerts: () => http.delete("/alerts").then(r => r.data),
  // Polling
  pollNow: () => http.post("/poll/now").then(r => r.data),
  // Portfolio
  portfolioSummary: () => http.get("/portfolio/summary").then(r => r.data),
  // Quotes for top ticker
  getQuotes: () => http.get("/quotes").then(r => r.data),
  // Coach
  coach: (id) => http.post(`/coach/${id}`).then(r => r.data),
  coachChat: (id, messages) => http.post(`/coach/${id}/chat`, { messages }, { timeout: 120000 }).then(r => r.data),
  coachChatHistory: (id) => http.get(`/coach/${id}/chat/history`).then(r => r.data),
  coachChatClear: (id) => http.delete(`/coach/${id}/chat/history`).then(r => r.data),
  // Status table sync
  syncStatus: (text) => http.post("/setups/sync-status", { text, auto_apply: true }, { timeout: 120000 }).then(r => r.data),
};

export default api;
